import type { Content } from "@prismicio/client"
import type { SliceComponentProps } from "@prismicio/react"
import classNames from "classnames"

import { IconList } from "@bounce/web-components"

/**
 * Props for `IconList`.
 */
export type IconListSliceProps = SliceComponentProps<Content.IconListSlice>

/**
 * Component for "IconList" Slices.
 */
const IconListSlice = ({ slice }: IconListSliceProps): React.JSX.Element => (
  <IconList
    {...slice.primary}
    items={slice.items}
    className={classNames(slice.variation === "iconListGrid" && "p-6 md:!flex-row md:gap-10")}
    containerClassName={classNames(
      slice.variation === "iconListGrid" && "sm:grid-cols-2 md:!mt-0 md:w-3/4 lg:!grid-cols-2",
    )}
  />
)

export default IconListSlice
